"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var SvgIcon_1 = __importDefault(require("@material-ui/core/es/SvgIcon/SvgIcon"));
var QuartermasterIcon = /** @class */ (function (_super) {
    __extends(QuartermasterIcon, _super);
    function QuartermasterIcon() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    QuartermasterIcon.prototype.render = function () {
        return (react_1.default.createElement(SvgIcon_1.default, null,
            react_1.default.createElement("svg", null,
                react_1.default.createElement("path", { d: "m 4.6747606,14.10871 0.03593,-5.1768119 h 0.342835 0.342835 l 0.03593,5.1768119 0.03593,5.176812 h -0.414701 -0.4147 z m -3.565792,0.479969 0.03624,-4.28544 h 0.342835 0.342835 l 0.03624,4.28544 0.03624,4.285441 h -0.415309 -0.415309 z m 7.098645,-0.04339 v -4.328832 l 0.377119,0.04339 0.377119,0.04339 0.03624,4.28544 0.03624,4.285441 H 8.6209756 8.2076196 Z M 0.16845159,9.5832846 c 0.03863,-0.131992 0.33057899,-1.9678745 0.64877799,-4.0797395 0.31819902,-2.111865 0.61737202,-3.885593 0.66483002,-3.941617 0.04746,-0.05602 0.352209,1.64101 0.677225,3.771188 0.325016,2.130177 0.622188,4.0118975 0.660384,4.1816005 0.06006,0.266843 0.01384,0.308552 -0.341937,0.308552 H 2.0663466 L 1.8279536,8.2462271 c -0.131117,-0.867373 -0.280288,-1.577042 -0.331491,-1.577042 -0.0512,0 -0.171645,0.570821 -0.267647,1.26849 -0.26040402,1.8924025 -0.25778602,1.8855935 -0.72482102,1.8855935 -0.32178699,0 -0.39123999,-0.04967 -0.33554299,-0.239984 z m 7.12287101,-0.06857 c 0.04036,-0.169703 0.337113,-2.0497875 0.65945,-4.1779665 0.322338,-2.128177 0.619984,-3.835846 0.661439,-3.794817 0.04145,0.04103 0.357591,1.905685 0.702525,4.143682 l 0.6271563,4.0690865 -0.331141,0.0446 c -0.182126,0.02453 -0.3641993,0.01155 -0.4046043,-0.02886 -0.04041,-0.0404 -0.171714,-0.7547175 -0.291796,-1.5873595 -0.12008,-0.832643 -0.258496,-1.513896 -0.307591,-1.513896 -0.04909,0 -0.19654,0.709669 -0.327656,1.577042 l -0.238394,1.5770415 h -0.411385 c -0.356941,0 -0.401673,-0.04083 -0.338003,-0.308553 z M 4.0411096,6.3606331 c 0.174981,-1.150212 0.454884,-3.001522 0.622005,-4.114023 0.167123,-1.1125 0.341334,-2.02272805 0.387137,-2.02272805 0.0458,0 0.348385,1.74331705 0.672407,3.87403805 0.324021,2.130722 0.618732,3.982032 0.654912,4.114023 0.05189,0.189309 -0.01991,0.239985 -0.339995,0.239985 -0.464705,0 -0.469688,-0.0124 -0.716539,-1.782743 -0.08939,-0.641102 -0.207812,-1.215071 -0.263155,-1.275486 -0.05534,-0.06042 -0.176695,0.464122 -0.269669,1.16564 -0.248446,1.874589 -0.255001,1.892589 -0.689102,1.892589 h -0.376148 z" }))));
    };
    return QuartermasterIcon;
}(react_1.Component));
exports.default = QuartermasterIcon;



//////////////////
// WEBPACK FOOTER
// ./src/components/icons/QuartermasterIcon.tsx
// module id = 793
// module chunks = 0